import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface IGetUserIdentityMigrationProgressParams {
}

export interface GetUserIdentityMigrationProgressResult extends IResult {
    totalSystemUsers: number;
    totalSystemUsersWithConflicts: number;
    totalSystemUsersWithIdentities: number;
}

export class GetUserIdentityMigrationProgressRequest extends Request<IGetUserIdentityMigrationProgressParams, GetUserIdentityMigrationProgressResult> {
  constructor(params: IGetUserIdentityMigrationProgressParams = {}) {
    super('getUserIdentityMigrationProgress', params);
  }
}
